import { render } from "./rate-accepted.vue?vue&type=template&id=296ff3ae&scoped=true"
import script from "./rate-accepted.vue?vue&type=script&lang=js"
export * from "./rate-accepted.vue?vue&type=script&lang=js"

import "./rate-accepted.vue?vue&type=style&index=0&id=296ff3ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296ff3ae"]])

export default __exports__